import { ROUTES } from "./constants/PathRoutes";

export const NAV_ITEMS = [
    {
        key: '0',
        label: 'Início',
        to: ROUTES.HOME
    },
    {
        key: '1',
        label: 'Produtos',
        to: ROUTES.PRODUTOS,
    },
    {
        key: '2',
        label: 'Blog',
        to: ROUTES.BLOG
    },
    {
        key: '3',
        label: 'FAQ',
        to: ROUTES.FAQ
    },
    {
        key: '4',
        label: 'Transparência',
        to: ROUTES.TRANSPARENCIA
    },
    {
        key: '5',
        label: 'AME',
        to: ROUTES.AME
    },
    // {
    //     key: '6',
    //     label: 'Médico Prescritor',
    //     to: PATHS_ROUTES.ASSOCIADO_MEDICO,
    //
    // }, {
    //     key: '7',
    //     label: 'Paciente Assoc.',
    //     to: PATHS_ROUTES.ASSOCIADO_PACIENTE,
    //
    // },
    //  {
    //     key: '8',
    //     label: 'Doador',
    //     to: '/associado/paciente',
    //
    // },
    //  {
    //     key: '9',
    //     label: 'AMAR',
    //     to: '/associado/paciente',
    //
    // },
    //  {
    //     key: '10',
    //     label: 'Fale conosco',
    //     to: '/associado/paciente',
    //
    // },
];

let endpoint;
let debug;


if (process.env.REACT_APP_ENV === 'PROD') {
    endpoint = process.env.REACT_APP_ENDPOINT
    debug = false

} else {
    endpoint = process.env.REACT_APP_LOCAL_ENDPOINT
    debug = true
}


export const BASE_ENDPOINT = endpoint;
export const DEBUG = debug;